<main>
  <app-externalmenu></app-externalmenu>
  <div class="wrapper  " [ngClass]="{'expanded': isSidebarCollapsed}">

    <div class="d-flex align-items-start mt-2">
      <div *ngIf="selected === 'W'" class="RolesDropdowns">
        <div class="Groupdropdown" *ngIf="!showModal">
          <div class="dropdown-header" (click)="toggleRoleDropdown($event)">
            {{ getSelectedRoleName() || 'select role' }}
            <span class="arrow" [class.open]="roleDropdownOpen">&#9662;</span>
          </div>
          <div class="dropdown-list" *ngIf="roleDropdownOpen" (click)="$event.stopPropagation()">
            <div class="dropdown-item" *ngFor="let role of roles" (click)="onRoleSelect(role)">
              {{ role.Role_Name || 'Unnamed role' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="selected === 'W' && !
      showModal" class="widgets-container1">
      <div class="widgets-grid1">
        <div *ngFor="let placeholder of placeholderWidgets; let i = index"
          [style.gridColumn]="'span ' + getWidgetColSpan(getWidgetSize(placeholder.id))"
          [style.gridRow]="'span ' + getWidgetRowSpan(getWidgetSize(placeholder.id))" class="details2 position-relative"
          [attr.data-index]="i" (dragover)="onDragOver($event, i)" (drop)="onDrop($event, i)">

          <ng-container *ngIf="selectedWidgetMap[placeholder.id]; else emptyWidget">
            <ng-container *ngTemplateOutlet="widgetTemplate; context: {
        $implicit: selectedWidgetMap[placeholder.id],
        isFirstSlot: i === 0 && selectedWidgetMap[placeholder.id],
           widgetIndex: i
      }">
            </ng-container>
          </ng-container>

          <ng-template #emptyWidget>

            <div class="custom-header2">
              <div class="position-relative w-100 h-100">
                <div class="center-section2">
                  <button (click)="openWidgetNameModal(placeholder.id)">+</button>

                </div>
              </div>
              <div class="right-icons2">
                <div class="d-flex align-items-center justify-content-center h-100">

                </div>
                <div class="icon-box2">
                </div>
              </div>
            </div>
            <div class="box2">
              <p class="widget-subtitle">
                No widget selected
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <ng-template #widgetTemplate let-widget let-isFirstSlot="isFirstSlot" let-widgetIndex="widgetIndex">
      <ng-container>

        <div class="custom-header2">
          <div class="position-relative w-100 h-100">
            <div class="center-section2">
              <div class="widget-actions">
                <div class="size_btns">
                  <button class="icon-btn" title="Decrease Size" (click)="resizeWidget(widget, 'decrease')">
                    <i class="fa-solid fa-minus"></i>
                  </button>
                  <button class="icon-btn" title="Increase Size" (click)="resizeWidget(widget, 'increase')">
                    <i class="fa-solid fa-plus"></i>
                  </button>

                  <button class="icon-btn drag-handle" draggable="true" (dragstart)="onDragStart($event, widgetIndex)"
                    (dragend)="onDragEnd($event)" title="Move Widget">
                    <i class="fa-solid fa-arrows-up-down-left-right"></i>
                  </button>
                </div>



              </div>


            </div>
          </div>

          <div class="right-icons2">
            <div class="d-flex align-items-center justify-content-center h-100">
              <div style="">
                <button class="remove-btn" (click)="removeWidget(widget)">remove</button>

              </div>
              <div class="line"></div>
              <div class="insights_btn" *ngIf="widget?.Widget_chartEnable">
                <img src="images/list.svg" alt="" title="View Graph" />
              </div>
              <div class="line" *ngIf="widget?.Widget_chartEnable"></div>

              <div *ngIf="widget?.WIDGET_REPORT && !widget?.Widget_chartEnable">
                <img class="opacityc" src="/images/view_exp.svg" alt="" />
              </div>
              <div class="line" *ngIf="widget?.WIDGET_REPORT && !widget?.Widget_chartEnable"></div>

              <div class="insights_btn p-2">
                <img style="padding: 3px;" src="/images/Dots_Vertical.svg" alt="" />
              </div>
            </div>
          </div>
        </div>


      </ng-container>
      <div class="box2">
        <p class="widget-subtitle" [ngClass]="{ 'sales-header': isFirstSlot }">
          {{ widget.Widget_Header?.trim() || widget.Widget_name }}
        </p>
        <h2 class="widget-title" [ngClass]="{ 'sales-header': isFirstSlot }">
          {{ widget.Widget_Preview?.trim() || 'No data available' }}
        </h2>
      </div>
      <div class="widget-footer d-none">
        <button class="primary" [ngClass]="{ 'sales-button': isFirstSlot }">
          {{ widget.Widget_name === 'Sales' ? 'Set Budget' : 'AXEL INSIGHTS' }}
        </button>
        <button style="color: blue" class="primary" [ngClass]="{ 'sales-button': isFirstSlot }">
          {{ widget.Widget_name === 'Sales' ? 'Notify Someone' : 'View Report' }}
        </button>
      </div>
    </ng-template>
    <div *ngIf="loading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="modal-backdrop" *ngIf="showWidgetNameModal">
      <div class="modal-content widget-modal">
        <h3 class="modal-title">Select a Widget</h3>
        <div class="divide"></div>
        <div class="widget-select-list">
          <div class="widget-option" *ngFor="let widget of availableWidgetNames"
            (click)="selectWidgetFor(currentPlaceholderId, widget)">
            {{ widget.Widget_name }}
          </div>
        </div>
        <div class="modal-actions">
          <button class="cancel-btn" (click)="showWidgetNameModal = false">Close</button>
        </div>
      </div>
    </div>


  </div>
</main>